import { Controller } from "@hotwired/stimulus"

// Menu mobile de l'en-tête (layouts/_header). Ouvre/ferme le panneau, tient
// aria-expanded / aria-label à jour, se referme sur Échap, clic extérieur,
// navigation Turbo et passage en desktop.
export default class extends Controller<HTMLElement> {
  static targets = ["burger", "menu"]

  declare readonly burgerTarget: HTMLButtonElement
  declare readonly menuTarget: HTMLElement

  private _onKeydown!: (e: KeyboardEvent) => void
  private _onClick!: (e: MouseEvent) => void
  private _onResize!: () => void
  private _beforeCache!: () => void

  connect() {
    this._onKeydown  = (e) => { if (e.key === "Escape" && this.isOpen) { this.close(); this.burgerTarget.focus() } }
    this._onClick    = (e) => { if (this.isOpen && !this.element.contains(e.target as Node)) this.close() }
    this._onResize   = () => { if (this.isOpen && window.innerWidth > 1180) this.close() }
    this._beforeCache = () => this.close()
    document.addEventListener("keydown", this._onKeydown)
    document.addEventListener("click", this._onClick)
    window.addEventListener("resize", this._onResize)
    document.addEventListener("turbo:before-cache", this._beforeCache)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    document.removeEventListener("click", this._onClick)
    window.removeEventListener("resize", this._onResize)
    document.removeEventListener("turbo:before-cache", this._beforeCache)
  }

  get isOpen() { return this.menuTarget.classList.contains("open") }

  toggle() { this.isOpen ? this.close() : this.open() }

  open() {
    this.menuTarget.classList.add("open")
    this.burgerTarget.setAttribute("aria-expanded", "true")
    this.burgerTarget.setAttribute("aria-label", "Fermer le menu")
  }

  close() {
    this.menuTarget.classList.remove("open")
    this.burgerTarget.setAttribute("aria-expanded", "false")
    this.burgerTarget.setAttribute("aria-label", "Ouvrir le menu")
  }
}
